import React, { useState, useEffect } from 'react'
import Styles from './styles.module.sass'
import ModalPortal from 'newComponents/ModalGlobal'
import { ModalTarjetaExpress } from 'newComponents/Modals'
import { InputTypeAndroid } from 'newComponents/Forms/InputType'
import { Error500 } from 'newComponents/Error/Error500'
import MainLayout from 'newComponents/Layout/MainLayout'
import CreditoGuestLayout from 'newComponents/Layout/CreditoGuestLayout'
import { useValidateAccount } from 'newHooks/useValidateAccount'
import { usePagoExpress } from 'newHooks/usePagoExpress';
import ModalLoading from 'newComponents/Loading'
import SectionLayout from 'newComponents/Layout/SectionLayout'

export default function PagoExpress() {
    const { flow, account, dataCard, showView } = useValidateAccount()
    const { 
        inputNumberCard,
        valNumero,
        showModalTarjetaInvalida,
        loading,
        errors,
        err500,
        handleSubmit,
        register,
        sendFormInformacionTarjeta,
        setInputNumberCard,
        handleClose,
        siRemove,
        noRemove
    } = usePagoExpress()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Express Pay Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <MainLayout>
            <CreditoGuestLayout flow={flow} >
                { loading && <ModalLoading />}
                <div className={Styles?.contPlanPayments}>
                    {err500 >= 500
                        ? <Error500 />
                        :
                            <SectionLayout title="Ingresa el número de tu tarjeta de Crédito Sears." >
                                <div className={Styles?.contPlanes}>
                                    <div className={Styles?.boxFormConsultar}>
                                        <form onSubmit={handleSubmit(sendFormInformacionTarjeta)} className={`${Styles?.formConsultar}`}>
                                            <InputTypeAndroid
                                                type="text"
                                                name="numero"
                                                id="numero"
                                                placeholder="Número de tarjeta"
                                                placeholderInt="Número de tarjeta"
                                                refs={register(valNumero)}
                                                autocomplete='numero'
                                                setNumero={setInputNumberCard}
                                                value={inputNumberCard}
                                                errorMessage={errors?.numero && errors?.numero.message}
                                                pattern={'number'}
                                                minLength={12}
                                                maxLength={13}
                                                max="9999999999999"
                                            />
                                            <div className={Styles?.boxBtnConsultar}>
                                                <button className={Styles?.btnConsultar}>Consultar</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </SectionLayout>
                    }
                </div>

                {showModalTarjetaInvalida &&
                    <ModalPortal type="modalSB" onClose={handleClose} >
                        <ModalTarjetaExpress remvoeAction={siRemove} awaitAction={noRemove}
                            body="Lo sentimos, el número de tarjeta que ingresaste no es válido." />
                    </ModalPortal>
                }
            </CreditoGuestLayout>
        </MainLayout>
    )
}